import { Table, TableBorderRadius, TableBorderStyle, TableColumn, TableHeaderTheme, TableRowTheme } from '@apply/components';
import { formatPhone } from '../../../../../../../../../../common/functions/formatPhone';
import { EntityPrincipal } from '../../../../../queries/borrowerEntityQueries';
import { CardSectionLabel } from '../../../../CardSectionLabel';

/** The entity's principals (name, phone, email); nothing when it has none. */
export const EntityPrincipalsTable = ({ principals }: { principals: EntityPrincipal[] }) => {
    if (principals.length === 0) {
        return null;
    }

    const rows = principals.map((principal) => ({ ...principal, phone: formatPhone(principal.phone) }));

    return (
        <div>
            <CardSectionLabel>Principals:</CardSectionLabel>
            <Table
                data={rows}
                headerTheme={TableHeaderTheme.Gray}
                rowTheme={TableRowTheme.White}
                borderStyle={TableBorderStyle.Solid}
                borderRadius={TableBorderRadius.Small}
                width='100%'
            >
                <TableColumn
                    columnKey='name'
                    header='Name'
                    width='35%'
                    abbreviateLongText={true}
                />
                <TableColumn
                    columnKey='phone'
                    header='Phone'
                    width='25%'
                />
                <TableColumn
                    columnKey='email'
                    header='Email'
                    width='40%'
                    abbreviateLongText={true}
                />
            </Table>
        </div>
    );
};
